import { render, staticRenderFns } from "./Product_V2.vue?vue&type=template&id=7794502d&"
import script from "./Product_V2.vue?vue&type=script&lang=js&"
export * from "./Product_V2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports